import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '@/assets/winclap-logo.svg';

export function UnauthorizedPage() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-full overflow-hidden">
      {/* Left panel — editorial black, same as Login */}
      <div className="hidden lg:flex lg:w-1/2 bg-brand-gray1 flex-col justify-between p-12 relative overflow-hidden">
        {/* Dot pattern background */}
        <svg
          className="absolute inset-0 w-full h-full opacity-[0.04]"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern id="dots" x="0" y="0" width="24" height="24" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.5" fill="white" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>

        <img
          src={logo}
          alt="Winclap"
          className="h-6 w-auto object-contain invert relative z-10"
        />

        <div className="space-y-4 relative z-10">
          <p className="text-[10px] font-medium tracking-widest text-white/30 uppercase">
            {t('errors.unauthorized.restricted_access')}
          </p>
          <h1 className="font-display text-5xl font-normal leading-tight text-white">
            {t('errors.unauthorized.headline_start')}<br />
            <span className="italic">{t('errors.unauthorized.headline_italic')}</span>
          </h1>
          <p className="text-brand-gray2 text-sm leading-relaxed max-w-xs">
            {t('errors.unauthorized.no_access_desc_left')}
          </p>
        </div>

        <p className="text-[#333333] text-sm relative z-10">
          {/* i18n-ok: marca + año */}
          ✦ Winclap &nbsp;·&nbsp; {new Date().getFullYear()}
        </p>
      </div>

      {/* Right panel — white */}
      <div className="flex w-full lg:w-1/2 flex-col items-center justify-center px-8 py-12 bg-white">
        {/* Mobile logo */}
        <img
          src={logo}
          alt="Winclap"
          className="mb-10 h-6 w-auto object-contain lg:hidden"
        />

        <div className="w-full max-w-sm space-y-8">
          <div className="space-y-2">
            <p className="text-[10px] font-medium tracking-widest text-brand-gray3 uppercase">
              {t('errors.unauthorized.error_code')}
            </p>
            <h2 className="font-display text-3xl font-normal text-brand-gray1">
              {t('errors.unauthorized.no_access_title')}
            </h2>
            <p className="text-sm text-brand-gray3 leading-relaxed">
              {t('errors.unauthorized.no_access_full_desc')}
            </p>
          </div>

          <div className="space-y-3">
            <Link
              to="/dashboard"
              className="flex items-center justify-between w-full rounded-md bg-brand-gray1 px-4 py-3 text-sm font-medium text-white hover:bg-[#333333] transition-colors group"
            >
              <span>{t('errors.unauthorized.back_to_home')}</span>
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </Link>
            <Link
              to="/tickets/select"
              className="flex items-center justify-between w-full rounded-md border border-brand-gray4 px-4 py-3 text-sm font-medium text-brand-gray2 hover:bg-brand-offwhite transition-colors group"
            >
              <span>{t('errors.unauthorized.go_to_tickets')}</span>
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
